export enum AllocationType {
	GeneralAdmission = 0,
	AssignedSeatingArrangement = 1,
    UnassignedSeatingArrangement = 2
}


// WEBPACK FOOTER //
// ./src/app/models/allocation-type.enum.ts